import { CheckCircleIcon } from "@heroicons/react/24/outline";

/**
 * The chip on a green drawer section: "Done" once there is nothing left to do there, or
 * "Done · not saved" while the change that finished it is still only in the drawer.
 */
export default function DoneChip({ unsaved = false }: { unsaved?: boolean }) {
  return (
    <span
      className={
        unsaved
          ? "inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-800"
          : "inline-flex items-center gap-1 rounded-full bg-green-100 px-2 py-0.5 text-[11px] font-semibold text-green-700"
      }
    >
      <CheckCircleIcon className="h-3.5 w-3.5" aria-hidden="true" />
      {unsaved ? "Done · not saved" : "Done"}
    </span>
  );
}
